var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Modal } from '../helpers/Modal';
import { DataStore } from '../../ts/helpers/DataStore';
export class Share extends Component {
    constructor(isDebugEnabled = false) {
        super('Share', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            let sharingTitle = '';
            $('.btn-share').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                button.addClass('loading');
                yield Modal.show('share');
                button.removeClass('loading');
                $('#share-link').html(button.attr('href'));
                sharingTitle = $('body').hasClass('page-template-page-template-dashboard') ? button.parents('.summary-block').find('.fw-bold').text() : DataStore.get().company;
            }));
            $('body').on('click', '#share-link', (event, button) => {
                navigator.clipboard.writeText(button.text());
                const text = $('html').attr('lang') == 'fr_FR' ? 'Le lien a été copié dans le presse-papier.' : 'Der Link wurde in die Zwischenablage kopiert.';
                alert(text);
            });
            $('body').on('click', '#btn-share-by-email', (event, button) => __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                $('#share-notification').addClass('d-none');
                const emailAddress = $('#share-email').val();
                if (emailAddress === '') {
                    $('#share-email').get(0).focus();
                    return;
                }
                button.addClass('loading');
                yield $.httpRequest({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    body: {
                        'action': 'share_by_email',
                        'email': emailAddress,
                        'company': sharingTitle,
                        'url': $('.btn-share').attr('href')
                    },
                    dataType: 'json'
                });
                $('#share-email').val('');
                button.removeClass('loading');
                $('#share-notification').removeClass('d-none');
            }));
            this.success();
        });
    }
}
